import {
  AccreditationSection,
  LearnerTestimonials,
} from "@/monarch/rules/degreeDetailRedesignTrafficV5_2/types";

export interface DegreeDetailPageV5_2Default {
  learnerTestimonials: LearnerTestimonials[];
  stats: {
    label: string;
    value: string;
  }[];
  statsSectionTitle: string;
  accreditation: AccreditationSection;
  showAccreditationSection: boolean;
}

export const UNCKennanFlaglerMbaTestimonialsDefaults: DegreeDetailPageV5_2Default =
  {
    learnerTestimonials: [
      {
        author: "Andre W., Class of 2015",
        textRaw:
          "The individuals I’ve been able to meet since I’ve been in the MBA@UNC program have changed the trajectory of my life.",
      },
      {
        author: "Stephanie W., Class of 2016",
        textRaw:
          "After starting the MBA@UNC program, my career really progressed. I was promoted several months after starting the program to chief operating officer, and then again...to CEO!",
      },
    ],
    stats: [
      {
        label: "Average salary five months post graduation with bonus",
        value: "$183,696",
      },
      {
        label: "Apple, The Home Depot, Google, and Procter & Gamble Co.",
        value: "Our alumni lead at",
      },
      {
        label: "Alumni in C-level positions",
        value: "1,300+",
      },
    ],
    statsSectionTitle: "The only online MBA with Tar Heel ROI",
    accreditation: {
      title: "Join our AACSB-Accredited school",
      description:
        "When you earn your MBA degree online from UNC Kenan-Flagler, you join a business school that’s accredited by the Association to Advance Collegiate Schools of Business (AACSB International), the longest-serving, most recognized accrediting body for business schools in the world.",
      image: "",
    },
    showAccreditationSection: true,
  };

export const ucBerkeleyMidsTestimonialsDefaults: DegreeDetailPageV5_2Default = {
  learnerTestimonials: [
    {
      author: "Erin B., data scientist at Fenix International",
      textRaw:
        "I rely heavily on the knowledge and confidence that I gained from the MIDS curriculum as I approach open-ended data science problems to inform company strategy at Fenix.",
    },
    {
      author: "Sombri E., software engineer for Britecore",
      textRaw:
        "The most valuable lesson I learned was that the ability to convey hard data in a relatable way is the difference between merely having some data and generating tangible actions.",
    },
  ],

  stats: [
    {
      label: "Choose between the accelerated, standard, or decelerate paths.",
      value: "3 learning paths",
    },
    {
      label: "Amazon, Apple, Facebook, Microsoft, and Google",
      value: "Our alumni lead at",
    },
    {
      label: "Focus on solving the world's most pressing data challenges",
      value: "Cutting edge curriculum",
    },
  ],
  statsSectionTitle: "Engage in a unique learning experience",
  accreditation: {
    title: "Join our accredited MIDS program",
    description:
      "The WASC-accredited program brings University of California, Berkeley to students across the country and around the world.",
    image: "",
  },
  showAccreditationSection: true,
};

export const ucBerkeleyCybersecurityTestimonialsDefaults: DegreeDetailPageV5_2Default =
  {
    learnerTestimonials: [
      {
        author: "Kelsey C, data scientist at Fitbit",
        textRaw:
          "The courses provided me with a solid foundation of a broad set of both technical and less technical skills, as well as final projects to showcase and discuss in interviews. Enrolling was certainly one of the best decisions I’ve made in my life!",
      },
      {
        author: "Divya G, data and applied scientist at Microsoft",
        textRaw:
          "The biggest advantage of the I School is the diversity of peers, which provides a unique opportunity to learn from each other. With the teaching faculty having years of experience in industry, they provide a great understanding of data science applications in real-world situations.",
      },
    ],
    stats: [
      {
        label:
          "Projected jobs each year for information security analysts, on average, from 2023 to 2033",
        value: "17,300",
      },
      {
        label:
          "Projected growth in employment for information security analysts from 2023 to 2033",
        value: "33%",
      },
      {
        label: "Thriving alumni network spanning 34 countries",
        value: "3,000+",
      },
    ],
    statsSectionTitle: "Thrive in the world of cybersecurity",
    accreditation: {
      title: "",
      description: "",
      image: "",
    },
    showAccreditationSection: false,
  };

export const nyuSteinhardtMentalHealthCounselingTestimonialsDefaults: DegreeDetailPageV5_2Default =
  {
    learnerTestimonials: [
      {
        author: "Parker Lynch",
        textRaw:
          "The diverse nature of Steinhardt fits me perfectly. It is truly a unique place for people interested in having a positive impact in the world.",
      },
    ],
    stats: [
      {
        label: "Practicum in a mental health setting",
        value: "100-hour",
      },
      {
        label: "Internship at an approved location",
        value: "600-hour",
      },
      {
        label: "of academic excellence",
        value: "130+ years",
      },
    ],
    statsSectionTitle: "Real-world training and experience",
    accreditation: {
      title: "Join Our MPCAC-accredited Program",
      description: `<p>
The online Master of Arts in Counseling for Mental Health and Wellness program is accredited by the Master’s in Psychology and Counseling Accreditation Council (MPCAC) under the Master’s in Counseling Accreditation Committee standards.
</p>
<p>
Counseling@NYU is registered by New York state as a license-qualifying program in mental health counseling. Students may be eligible for licensure in states outside New York; however, requirements vary from state to state.
</p>`,
      image: "",
    },
    showAccreditationSection: true,
  };

export const maryvilleProgramsTestimonialsDefaults: DegreeDetailPageV5_2Default =
  {
    learnerTestimonials: [
      {
        author: "Junah Castil, Class of 2022",
        textRaw:
          "If you start, finish it. Pursue your dreams to the end. Maryville offers a lot of help; they will walk with you from beginning to end.",
      },
      {
        author: "Danielle Van Komen, Class of 2019",
        textRaw:
          "I ended up being really happy that I chose Maryville. It’s online, and the price was comparable to all the surrounding universities, so it ended up being a good choice. Online learning is everything I expected it to be. It was so flexible with my work and family life that it’s just been a fairly smooth sail.",
      },
    ],
    stats: [
      {
        label: "SAT/ACT or GMAT/GRE not required",
        value: "No test scores",
      },
      {
        label: "Put your hard-earned credits to work",
        value: "Transfer your credits",
      },
      {
        label: "Online graduate students",
        value: "2,900+",
      },
    ],
    statsSectionTitle: "Join our Saints community",
    accreditation: {
      title: "Join our HLC-accredited school",
      description:
        "The Higher Learning Commission champions quality higher education by working proactively in support of students, institutions and their communities. HLC accredits degree-granting colleges and universities in the United States.",
      image: "",
    },
    showAccreditationSection: true,
  };

export const londonSchoolDefaults: DegreeDetailPageV5_2Default = {
  learnerTestimonials: [
    {
      author: "Julian K.",
      textRaw:
        "Having people share their diverse experiences in the classroom has brought what I’m studying to life. Being at LSE makes you realise how big the world is, and how important it is to highlight our different stories.",
    },
    {
      author: "Andrea S.",
      textRaw:
        "I’m going to take advantage of all the opportunities that we have at LSE. I’m looking forward to making connections with people I never thought I’d meet. LSE is so international - you don’t get that anywhere else.",
    },
  ],
  stats: [
    {
      label: "Students across the globe",
      value: "50,000+",
    },
    {
      label: "Our learning network spans all across the globe",
      value: "190+ countries",
    },
    {
      label:
        "Alumni include seven Nobel Prize winners – including Nelson Mandela",
      value: "Outstanding alumni",
    },
  ],
  statsSectionTitle: "Academic excellence meets unparalleled access",
  accreditation: {
    title: "",
    description: "",
    image: "",
  },
  showAccreditationSection: false,
};
